export default "__VITE_ASSET__8d13beba__"